import { permissionObj } from '../../../../Helpers/permission';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../components/buttons/IconButtons';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import VehicleFields from './subComponents/VehicleFields';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import { TABS_VEHICLE_UPDATE } from './model/model';
import { SUGGESTION_MODE_OPTION } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import UpdateVehicleApp from './Functionality/UpdateVehicleApp';
import StepperTabs from '../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../components/StepperTabs/StepTab';
import VehicleCommons from './Functionality/VehicleCommons';

const UpdateVehicle = () => {
    const {
        DEV,
        permission,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        item,
        handleChange,
        emptyFields,
        getVehicleStatus,
        currentTime,
        photoPicker,
        setPhotoPicker,
        handleUpdate,
        contractorId,
        supplierId, 
    } = UpdateVehicleApp();

    const { handleOnBack } = VehicleCommons();
    const canUpdateVehicle =
        DEV || !!supplierId || !!contractorId || permission?.includes(permissionObj.WEB_VEHICLE_UPDATE);

    return (
        <>
            <HeadTittle name={'update'} onBack={handleOnBack}>
                {canUpdateVehicle && (
                    <ButtonAction
                        id='btn_up_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                )}
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_VEHICLE_UPDATE.VEHICLE_DETAILS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VEHICLE_UPDATE.VEHICLE_DETAILS.INDEX && (
                        <VehicleFields
                            item={item}
                            vehicle={item}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            getVehicleStatus={getVehicleStatus}
                            currentTime={currentTime}
                            isUpdate={true}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_VEHICLE_UPDATE.PHOTO.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VEHICLE_UPDATE.PHOTO.INDEX && (
                        <CustomPhotoPicker
                            id='fp_up_create_photo_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.UPDATE}
                            accept={{ ...FILE_TYPE.IMAGE }}
                            showBtnCamera={false}
                            validateFace={false}
                            classWith={'content-center-w-400px'}
                            showPreview={true}
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default UpdateVehicle;
